import { useContext } from 'react';

import JobContext, { type IJobContext } from './Context';

const useJobContext = (): IJobContext => useContext(JobContext);

export default useJobContext;
